module.exports = __webpack_public_path__ + "static/media/finished_orange.7a485b2b.svg";